import { render } from "./AdminCustomerOnboard.vue?vue&type=template&id=17579a46&scoped=true&ts=true"
import script from "./AdminCustomerOnboard.vue?vue&type=script&lang=ts"
export * from "./AdminCustomerOnboard.vue?vue&type=script&lang=ts"

import "./AdminCustomerOnboard.vue?vue&type=style&index=0&id=17579a46&scoped=true&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17579a46"]])

export default __exports__